import { render, staticRenderFns } from "./bzgz.vue?vue&type=template&id=3c650df0&scoped=true&"
import script from "./bzgz.vue?vue&type=script&lang=js&"
export * from "./bzgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c650df0",
  null
  
)

export default component.exports